// src/components/Footer.js
import React from 'react';
import { SocialIcon } from 'react-social-icons';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  background-color: #0C2340;
  color: #AE9142;
  padding: 20px;
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <p>&copy; 2025 Shamrock Services. All rights reserved.</p>
      <SocialIcon url='https://www.instagram.com/shamrock_services_llc/' />
      <SocialIcon url='https://www.facebook.com/profile.php?id=61562666398013' />
    </FooterWrapper>
  );
};

export default Footer;